<template>
  <li class="cx-list__item">
    <a 
      ref="trigger"
      :aria-label="$t(`socialMedia.${type}`)"
      :title="$t(`socialMedia.${type}`) + (hasMore ? '' : ' - ' +getName(subscriptions[0]))"
      :href="hasMore ? '#' : getLink(subscriptions[0])"
      rel="noopener noreferrer" 
      class="cx-link"
      tabindex="0"
      :role="hasMore ? 'button' : null"
      target="_blank"
      @click="(e) => hasMore && handleClick(e)"
    >
      <template v-if="type === 'twitter'">
        <i class="fa-brands fa-x-twitter"></i>
      </template>
      <template v-else-if="type === 'xiaohongshu'">
        <i class="fa-kit fa-xiaohongshu"></i>
      </template>
      <template v-else>
        <i :class="`fa${type != 'globe' ? 'b' : 's'}  fa-${type}${type == 'facebook' ? '' : ''}`"></i>
      </template>
    </a>
    <div class="cx-modal--full social-media-subscription-modal" 
      ref="focus_container"
      v-if="hasMore && showModal"
      v-trap-focus="{ escFunc:closeModal }">
      <div class="cx-modal__body">
        <div class="cx-card--notify">
          <div class="cx-wrap--article">
            <div class="cx-div">
              <template v-if="type === 'twitter'">
                <i class="fa-2x fa-brands fa-x-twitter"></i>
              </template>
              <template v-else-if="type === 'xiaohongshu'">
                <i class="fa-2x fa-kit fa-xiaohongshu"></i>
              </template>
              <template v-else>
                <i :class="`fa-2x fa${type != 'globe' ? 'b' : 's'} fa-${type}${type == 'facebook' ? '' : ''}`"></i>
              </template>
              <h2 class="cx-t10">
                {{$t('socialMedia.followUs', { media: $t(`socialMedia.${toId(type)}`) })}}
              </h2>
            </div>
            <div class="cx-div cx-t20">
              <ul class="cx-list--vertical">
                <li v-for="s in subscriptions" 
                  class="cx-list__item"
                  :key="s.link">
                  <img v-if="showQR" :src="s.link" :alt="s.name">
                  <a v-else 
                    class="cx-link"
                    :href="s.link" 
                    rel="noopener noreferrer" 
                    target="_blank"
                  >{{s.name}}</a>
                </li>
              </ul>
            </div>
            <div class="cx-div" v-if="type == 'weixin'"
              v-html="$t('socialMedia.weixinRemark')"
            ></div>
            <div class="cx-div cx-t02">
              <a class="cx-link "
                @click.prevent="closeModal">
                <span class="cx-link__icon"><i class="fal fa-times-circle"></i></span>
                <span>{{$t('action.close')}}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import qr from 'qrcode';
import autoFocus from '../mixins/autoFocus';

export default {
  name: 'social-media-subscription-button',
  uit() {
    return [
      ['action', ['close']],
      ['socialMedia', [
        'followUs', 'facebook', 'weibo', 'weixin', 'xiaohongshu',
        'x-twitter', 'twitter', 'instagram', 'youtube', 'tiktok',
        'pinterest', 'vk', 'globe',
        'weixinRemark'
      ]]
    ]
  },
  mixins: [autoFocus],
  props: {
    type: {
      type: String,
      default: 'globe'
    },
    subscriptions: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      showModal: false,
      mount: false
    }
  },
  mounted() {
    this.mount = true;
    this.convertLinkToQrCode();
  },
  computed: {
    showQR() {
      return this.type == 'weixin';
    },
    hasMore() {
      return this.subscriptions.length > 1 || this.showQR;
    }
  },
  methods: {
    convertLinkToQrCode() {
      if (this.mount && this.showQR) {
        this.subscriptions.forEach((s, idx) => {
          qr.toDataURL(s.link)
            .then((url) => {
              this.subscriptions[idx].link = url;
            }).catch((err) => { console.log(err) });
        })
      }
    },
    toId(str) {
      let res = str.split('-');
      return res.shift() + res.map(s => this.$options.filters.capitalize(s)).join('');
    },
    getName(subscription) {
      return (subscription && subscription.name) || '';
    },
    getLink(subscription) {
      return (subscription && subscription.link) || '#';
    },
    handleClick(e) {
      e.preventDefault();
      this.openModal();
    },
    openModal() {
      this.showModal = true;
      setTimeout(this._af_autoFocus, 0);
    },
    closeModal() {
      this.showModal = false;
      this.$refs.trigger && this.$refs.trigger.focus();
    }
  },
  watch: {
    subscriptions: {
      handler: function() {
        this.convertLinkToQrCode()
      },
      deep: true,
    }
  }
}
</script>

<style lang="scss">
.social-media-subscription-modal {
  @include set-font(.9);
  color: $color-black;
  h2{
    @extend %style-subtitle;
    margin-top: $space-sm;
  }
  li{
    min-width: 250px;
    &:not(:last-child){
      margin-bottom: $int-space-xs;
      padding-bottom: $int-space-xs;
      border-bottom: 1px solid $color-border;
    }
  }
  a{
    color: $color-primary !important;
    &:hover{
      color: darken($color-primary, 10%) !important;
    }
  }

}
</style>

<style>
a > .fa-weixin:hover {
  color: #09B83E;
}
a > .fa-x-twitter:hover {
  color: #1d9bf0;
}
a > .fa-tiktok:hover {
  color: #fe2c55;
}
a > .fa-xiaohongshu:hover {
  color: #FF2741;
}
</style>
